/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EnergyPriceImportRequest } from '../../models/energy-price-import-request';
import { EnergyPriceImportResponse } from '../../models/energy-price-import-response';

export interface ImportEnergyPrices$Params {
  
    /**
     * CSV to import
     */
    body: EnergyPriceImportRequest
}

export function importEnergyPrices(http: HttpClient, rootUrl: string, params: ImportEnergyPrices$Params, context?: HttpContext): Observable<StrictHttpResponse<EnergyPriceImportResponse>> {
  const rb = new RequestBuilder(rootUrl, importEnergyPrices.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EnergyPriceImportResponse>;
    })
  );
}

importEnergyPrices.PATH = '/admin/energy-prices/import';
